export const messages = {
  en: {
    systemGoldSetting: {
      title: 'Gold Information',
      settingId: 'Setting ID',
      goldName: 'Name',
      goldType: 'Type',
      buyPrice: 'Purchase Price',
      usePrice: 'Usage Price',
      validity: 'Validity',
      state: 'Status',
      operation: 'Operation',
      editButton: 'Edit',
      addButton: 'Add Gold Setting',
      editTitle: 'Edit Gold Setting',
      rules: {
        goldNameRequired: 'Please input gold name',
        goldTypeRequired: 'Please input gold type'
      }
    }
  },
  zh: {
    systemGoldSetting: {
      title: '金币信息',
      settingId: '设置ID',
      goldName: '名称',
      goldType: '类型',
      buyPrice: '购买价格',
      usePrice: '使用价格',
      validity: '有效期',
      state: '状态',
      operation: '操作',
      editButton: '修改',
      addButton: '添加金币设置',
      editTitle: '修改金币设置',
      rules: {
        goldNameRequired: '请输入金币名称',
        goldTypeRequired: '请输入金币类型'
      }
    }
  }
}